/* eslint-disable max-statements */
/* eslint-disable complexity */
import React, {useState, useEffect, Fragment} from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import priceFormatter from "../../../utils/helpers/price-formatter";
import PostInspectionDiyChallanList from "../post-inspection-diy-challan-list";
import { BREAKUP_CHARGES, POP_UPS } from "./constant";
import PostInspectionDiyHoldbacksV3 from "../post-inspection-diy-holdbacks-v3";
import InfoIcon from "./images/info.svg";
import InfoOffer from "./images/info-offer.svg";
import { sendCustomGaEvents } from "../../../tracking";
import { priceViewScreen } from "./tracking";
import GsAssuredPrice from "./gs-assured-card";
import ArrowIcon from "../arrow";
import { NUMBER } from "../../../constants/app-constants";
import { Label } from "@cars24/turbo-web/lib/label";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { Heading } from "@cars24/turbo-web/lib/heading";
import { CmsContent } from "@cars24/turbo-web/lib/cms-content";
import PostInspectionDiyModal from "../post-inspection-diy-modal";
import { BottomSheet } from "@cars24/turbo-web/lib/bottom-sheet";
import { Button } from "@cars24/turbo-web/lib/button";
import { Text } from "@cars24/turbo-web/lib/text";
import { kavachBannerClicked, kavachBannerViewed, kavachKnowMoreBottomSheet } from "../post-inspection-diy/tracking";

const PostInspectionDiyOfferDeductions = ({
    inspectionResponse,
    auctionResponse,
    priceBreakup,
    isGsAssuredPrice = false,
    allowViewDetails =  true,
    children,
    pendingLoanAmount = NUMBER.ZERO,
    showBottomText = true,
    fetchOffersDetailsCmsConnect,
    fetchKavachBannerConnect,
    history
}) => {
    const { tokens } = useTokens();
    const successColor = tokens.text_state_text_success;
    const {
        showServiceCharge = true,
        appointmentId,
        priceDo = {},
        auction,
        purchaseRequestStatus,
        priceDiscovery,
        token
    } = inspectionResponse || {};
    const { priceExpiryDate = "", priceExpiryInDays = "" } = priceDo || {};
    const { auctionEndTime, customerAuctionCount } = auction || {};
    const { offeredPrice, isExpired } = auctionResponse || {};
    const { deductions, priceAfterDeductions, additions } = priceBreakup || {};
    const {
        charges = [],
        totalChallanAmount,
        totalChallanCount,
        serviceChargeAmount,
        totalOffers,
        holds = []
    } = deductions || {};
    const { offers } = additions || {};
    const isAnyChargeAvailable = charges && !!charges.length;
    const [selectPopUpType, setSelectPopupType] = useState(null);
    const [offersCmsData, setOffersCmsData] = useState(null);
    const [bottomSheetData, setBottomSheetData] = useState(null);
    const [kavachBannerData, setKavachBannerData] = useState(null);
    const { imageUrl: kavachBanner } = kavachBannerData || {};

    const {
        imageUrl,
        subtitle,
        button
    } = bottomSheetData || {};
    const {title: ctaText} = button || {};

    const { bottomSheetContent = {} } = offersCmsData || {};
    const { title = "", description = "" } = bottomSheetContent || {};

    useEffect(() => {
        sendCustomGaEvents({
            ...priceViewScreen,
            eventLabel: appointmentId,
            eventValue: customerAuctionCount
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (token) {
            fetchKavachBannerConnect(token).then((res) => {
                setKavachBannerData(res);
                if (res) {
                    sendCustomGaEvents({
                        ...kavachBannerViewed,
                        eventAction: "kavach_view_web_price_disc",
                        eventLabel: appointmentId
                    });
                }
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);

    useEffect(() => {
        if (selectPopUpType === POP_UPS.OFFERS && !offersCmsData) {
            fetchOffersDetailsCmsConnect().then((res) => {
                const { offer = {} } = res.data || {};
                setOffersCmsData(offer);
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectPopUpType]);

    const handleBottomSheet = (label, data) => {
        if (label === BREAKUP_CHARGES.SERVICE_CAHRGES) {
            setSelectPopupType(POP_UPS.SERVICE_CHARGE);
        }
        if (label === BREAKUP_CHARGES.SPP_CHARGES) {
            setSelectPopupType(POP_UPS.SPP_CHARGES);
            setBottomSheetData(data);
            sendCustomGaEvents({
                ...kavachKnowMoreBottomSheet,
                eventLabel: `${appointmentId}`
            });
        }
    };

    const handleKavachClick = () => {
        sendCustomGaEvents({
            event: "kavach_click",
            eventAction: "DIY_kavach_bottomsheet_click",
            eventCategory: "Seller_Kavach",
            eventLabel: `${appointmentId}`
        });
        setSelectPopupType(null);
        history.push("/kavach/");
    };

    const handleKavachBannerClick = () => {
        sendCustomGaEvents({
            ...kavachBannerClicked,
            eventAction: "kavach_banner_click_web_price_disc",
            eventLabel: appointmentId
        });
        history.push("/kavach/");
    };

    const RenderChargesList = () => {
        return (
            charges && !!charges.length && charges.map(({label, additionalData,  amount }, index) => (
                <li key={`${label}_${index}`} styleName={`${label === BREAKUP_CHARGES.CHALLAN_CHARGES ? "styles.challanChargeWrapper" : ""}`}>
                    <div styleName={"styles.chargeList"}>
                        <label>
                            {additionalData && additionalData.heading ? additionalData.heading : label}
                            {additionalData && additionalData.bottomSheet && <img onClick={() => handleBottomSheet(label, additionalData.bottomSheet)} src={InfoIcon} alt="info_icon"/>}
                        </label>
                        <span>
                        -₹<font>{priceFormatter(amount)}</font>
                        </span>
                    </div>
                    {label === BREAKUP_CHARGES.CHALLAN_CHARGES && !!totalChallanAmount && allowViewDetails &&
                        <span styleName={"styles.viewChallans"} onClick={() => setSelectPopupType(POP_UPS.PENDING_CHALLAN)}>
                            View challans
                            <ArrowIcon grey={"GreyArrow"} rotateBy={-90} />
                        </span>
                    }
                </li>
            ))
        );
    };

    const  GetNetOfferValue = () => {
        let price = offeredPrice;
        if (!showServiceCharge) {
            price = offeredPrice - serviceChargeAmount;
        }
        return (
            <li styleName={"styles.cars24Offer"}>CARS24 offer
                <span>₹<font>{priceFormatter(price)}</font>
                </span>
            </li>
        );
    };

    const GetInHandPrice = () => {
        return (<span>₹<font>{priceFormatter(priceAfterDeductions - pendingLoanAmount)}</font></span>);
    };

    const CardDetails = () => {
        return (
            <React.Fragment>
                <li styleName={"styles.finalOfferWrapper"}>
                    <div styleName={"styles.finalOffer"}>
                        Final in-hand offer
                        <span>
                ₹<font>{priceFormatter(priceAfterDeductions - pendingLoanAmount)}</font>
                        </span>
                    </div>
                </li>
            </React.Fragment>
        );
    };

    const showCard = () => {
        return (
            <Fragment>
                <GsAssuredPrice
                    auctionEndTime={auctionEndTime}
                    priceExpiryDate={priceExpiryDate}
                    priceExpiryInDays={priceExpiryInDays}
                    isGsAssuredPrice={isGsAssuredPrice}
                    purchaseRequestStatus={purchaseRequestStatus}
                    showBottomText={showBottomText}
                    priceDiscovery={priceDiscovery}
                >
                    <div styleName={"styles.offerValue"}>
                        <GetInHandPrice/>
                    </div>
                    <GetNetOfferValue/>
                    { children }
                    <RenderChargesList />
                    {
                        !!totalOffers && offers && !!offers.length && offers.map(({ label, amount }, index) => (
                            <li styleName="styles.offers" key={`offers-${index}`}>
                                <Label color={successColor} level={NUMBER.FOUR} fontWeight="medium">{label}
                                    <img src={InfoOffer} onClick={() => setSelectPopupType(POP_UPS.OFFERS)}/>
                                </Label>
                                <Label color={successColor} level={NUMBER.FOUR} fontWeight="medium">+₹{priceFormatter(amount)}</Label>
                            </li>))
                    }
                    <CardDetails/>
                </GsAssuredPrice>
                {
                    !!kavachBanner &&
                    <img
                        styleName="styles.kavachBanner"
                        src={kavachBanner}
                        alt="kavach_banner"
                        onClick={handleKavachBannerClick}
                    />
                }
            </Fragment>);
    };

    return (
        <React.Fragment>
            {(isAnyChargeAvailable || !!totalChallanCount || (!!serviceChargeAmount && showServiceCharge) || !!offeredPrice) && showCard()}
            {
                selectPopUpType === POP_UPS.PENDING_CHALLAN && <PostInspectionDiyChallanList onClose={() => setSelectPopupType(null)}/>
            }
            {
                !isExpired && !!holds.length && <PostInspectionDiyHoldbacksV3
                    onClose={() => setSelectPopupType(null)}
                    showAuctionCard={false}
                />
            }
            {
                selectPopUpType === POP_UPS.OFFERS && description && title &&
                <PostInspectionDiyModal
                    height="400px"
                    isOpen={true}
                    width="520px"
                    showCloseButton={true}
                    onClose={() => setSelectPopupType(null)}
                >
                    <div styleName="styles.bottomSheetContent">
                        <Heading level={NUMBER.FOUR}>{title}</Heading>
                        <CmsContent content={description} />
                    </div>
                </PostInspectionDiyModal>
            }
            {
                !!serviceChargeAmount && showServiceCharge && selectPopUpType === POP_UPS.SERVICE_CHARGE &&
                // <SemiModal>
                    <BottomSheet
                        overlayColor={tokens.background_surface_overlay_primary}
                        onClose={() => setSelectPopupType(null)}
                        height="max-content"
                        isOpen={true}
                        onOverlayClick={() => setSelectPopupType(null)}
                    >
                        <div styleName={"styles.serviceChargeModal"}>
                            <div styleName={"styles.serviceChargePopup"}>
                                <div styleName={"styles.serviceChargeHeader"}>
                                    <h2>Service charge</h2>
                                </div>
                                <div styleName={"styles.whyCharges"}>
                                    <h3>Why a service charge?</h3>
                                    <p>This is a nominal fee we charge for the services we provide. This includes documentation, and legal and financial support until the RC is transferred</p>
                                </div>
                            </div>
                        </div>

                    </BottomSheet>
            }

            {
                selectPopUpType === POP_UPS.SPP_CHARGES &&
                <BottomSheet
                    overlayColor={tokens.background_surface_overlay_primary}
                    onClose={() => setSelectPopupType(null)}
                    height="max-content"
                    isOpen={true}
                    onOverlayClick={() => setSelectPopupType(null)}
                >
                    <img src={imageUrl} alt="kavach_image" height={200} styleName={"styles.kavachImg"} />
                    <Text
                        align="left"
                        as="p"
                        fontWeight="regular"
                        size="200"
                        transform="none"
                        color={tokens.text_default_text_secondary}
                    >
                        {subtitle}
                    </Text>
                    <div styleName={"styles.knowMoreCta"}>
                        <Button
                            label={ctaText}
                            onClick={handleKavachClick}
                        />
                    </div>
                </BottomSheet>
            }
        </React.Fragment>
    );
};

PostInspectionDiyOfferDeductions.propTypes = {
    inspectionResponse: PropTypes.object,
    auctionResponse: PropTypes.object,
    priceBreakup: PropTypes.object,
    isGsAssuredPrice: PropTypes.bool,
    allowViewDetails: PropTypes.bool,
    children: PropTypes.any,
    pendingLoanAmount: PropTypes.number,
    showBottomText: PropTypes.bool,
    fetchOffersDetailsCmsConnect: PropTypes.func,
    fetchKavachBannerConnect: PropTypes.func,
    history: PropTypes.object
};

export default PostInspectionDiyOfferDeductions;

